import * as React from "react";
import styled from "styled-components";

export function ReviewCard({ type, imageSrc, name }) {
  if (type === "profile") {
    return (
      <ProfileCard>
        <ProfileImageWrapper>
          <ProfileImage>
            <BackgroundImage loading="lazy" src={imageSrc} alt="" />
            <Overlay />
            <ProfileCircle>
              <NameWrapper>
                <Name>{name}</Name>
              </NameWrapper>
            </ProfileCircle>
          </ProfileImage>
        </ProfileImageWrapper>
      </ProfileCard>
    );
  }

  return (
    <CardWrapper>
      <CardImage loading="lazy" src={imageSrc} alt="" />
    </CardWrapper>
  );
}

const CardWrapper = styled.div`
  align-self: stretch;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  width: 555px;
  margin: auto 0;
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  transform: perspective(1000px) rotateX(0) rotateY(0);
  
  &:hover {
    transform: perspective(1000px) rotateX(2deg) rotateY(-2deg) translateY(-10px);
    box-shadow: 0 25px 45px rgba(0, 0, 0, 0.15);
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), transparent);
    pointer-events: none;
  }

  @media (max-width: 991px) {
    max-width: 100%;
  }
  
  @media (max-width: 500px) {
    min-width: 180px;
    width: 230px;
  }
`;

const CardImage = styled.img`
  aspect-ratio: ${(props) => (props.src.includes("ext_4") ? "0.6" : "1.75")};
  object-fit: contain;
  width: ${(props) => (props.src.includes("ext_4") ? "192px" : "555px")};
  max-width: 100%;
  transition: transform 0.3s ease;
  
  ${CardWrapper}:hover & {
    transform: scale(1.03);
  }
`;

const ProfileCard = styled(CardWrapper)`
  color: var(--White, #fff);
  font: 500 24px/1.4 Manrope, sans-serif;
`;

const ProfileImageWrapper = styled.div`
  border-radius: 16px;
  background: var(--Secondary, #232323);
  display: flex;
  max-width: 100%;
  width: 555px;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2), inset 0 0 0 1px rgba(255, 255, 255, 0.1);
  
  &:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, var(--primary-color), var(--secondary-color));
    z-index: -1;
    border-radius: 18px;
    opacity: 0.6;
    filter: blur(4px);
  }
  
  @media (max-width: 500px) {
    width: 230px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.7));
  z-index: 1;
`;

const ProfileImage = styled.div`
  display: flex;
  position: relative;
  min-height: 318px;
  width: 100%;
  align-items: flex-end;
  padding: 80px 56px 0;
  
  @media (max-width: 991px) {
    padding-left: 20px;
  }
  
  @media (max-width: 500px) {
    min-height: 220px;
    padding: 40px 20px 0;
  }
`;

const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
  
  ${ProfileCard}:hover & {
    transform: scale(1.05);
  }
`;

const ProfileCircle = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  width: 238px;
  flex-direction: column;
  align-items: flex-end;
  aspect-ratio: 1;
  padding: 88px 48px 0;
  
  @media (max-width: 991px) {
    padding-left: 20px;
  }
  
  @media (max-width: 500px) {
    width: 160px;
    padding: 45px 20px 0;
  }
`;

const NameWrapper = styled.div`
  width: 135%;
  background: linear-gradient(45deg, var(--primary-color), rgba(2, 73, 95, 0.7));
  border-radius: 8px;
  padding: 12px 18px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateY(0);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  ${ProfileCard}:hover & {
    transform: translateY(-5px);
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 991px) {
    padding: 10px 20px;
  }
  
  @media (max-width: 500px) {
    padding: 8px 15px;
    font-size: 18px;
  }
`;

const Name = styled.span`
  font-family: Manrope, sans-serif;
  font-weight: 700;
  font-size: 26px;
  display: block;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
`;
